const initialState = {
    data: [],
  };
  
  const grupyAktReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_GRUPY_AKT':
        return { ...state, data: action.payload };
      default:
        return state;
    }
  };
  
  export default grupyAktReducer;